import { useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { Select } from "@/components/shared/forms";

export const VIDEO_AREA_SIZE_SMALL_TYPE = "Small";
export const VIDEO_AREA_SIZE_MEDIUM_TYPE = "Medium";
export const VIDEO_AREA_SIZE_LARGE_TYPE = "Large";

export default function VideoWithTitleSettings() {
  const {
    props,
    actions: { setProp },
  } = useNode((query) => ({
    props: query.props,
  }));
  const { t } = useTranslation();

  const handleSelect = React.useCallback(
    (value) => {
      setProp((props) => {
        return (props.videoAreaSize = value);
      });
    },
    [setProp]
  );

  const VIDEO_AREA_SIZE_OPTIONS = React.useMemo(
    () =>
      [
        VIDEO_AREA_SIZE_SMALL_TYPE,
        VIDEO_AREA_SIZE_MEDIUM_TYPE,
        VIDEO_AREA_SIZE_LARGE_TYPE,
      ].map((size) => ({
        label: t(`preference-panel.${size.toLowerCase()}`),
        value: size,
      })),
    [t]
  );

  return (
    <div className="p-4">
      <Select
        name="video-area-size"
        label={t("preference-panel.video-area-size")}
        options={VIDEO_AREA_SIZE_OPTIONS}
        value={props.videoAreaSize}
        onChange={handleSelect}
      />
    </div>
  );
}
